import { createSlice } from "@reduxjs/toolkit";

const initialState: any = {
  user: {
    isLoggedIn: false,
  },
};

const auth = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setUserInfo: (state, action) => {
      state.user = {
        ...state.user,
        isLoggedIn: true,
        ...action.payload,
        token: `Bearer ${action.payload.token}`,
      };
    },
    updateUserInfo: (state, action) => {
      state.user = {
        ...state.user,
        ...action.payload,
      };
    },
  },
});

export const { setUserInfo, updateUserInfo } = auth.actions;

export default auth.reducer;
